<template>
  <div class="hero-slider">
    <div class="slider-container">
      <!-- Main Menu (Desktop) -->
      <div class="main-menu">
        <sidebar :categories="categories" />
      </div>

      <!-- Main Slider -->
      <div class="slider-main">
        <div class="slides-wrapper" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
          <div v-for="(slide, index) in slides" :key="index" class="slide">
            <a :href="slide.link">
              <img
                :src="slide.image"
                :alt="slide.title"
                :loading="index === 0 ? 'eager' : 'lazy'"
                :fetchpriority="index === 0 ? 'high' : 'auto'"
                width="800"
                height="400"
              />
            </a>
          </div>
        </div>

        <!-- Navigation Arrows -->
        <button @click="prevSlide" class="slider-arrow prev" aria-label="Previous slide">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
        </button>
        <button @click="nextSlide" class="slider-arrow next" aria-label="Next slide">
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>

      <!-- Right Tall Banner -->
      <div class="side-banners">
        <a
          v-if="heroBanner"
          :href="heroBanner.link || '#'"
          class="hero-banner-tall"
        >
          <img :src="heroBanner.image" :alt="heroBanner.title" />
        </a>
      </div>
    </div>
  </div>
 </template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import Sidebar from './Sidebar.vue'

const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  },
  sliders: {
    type: Array,
    default: () => []
  },
  heroBanner: {
    type: Object,
    default: null
  }
})

const currentSlide = ref(0)
let autoPlayInterval = null

const fallbackSlides = [
  { id: 'fallback-1', title: 'Welcome to IbomStore', image: '/images/slides/1.webp', link: '#' },
  { id: 'fallback-2', title: 'Shop Amazing Deals', image: '/images/slides/2.webp', link: '#' }
]

const fallbackHeroBanner = {
  id: 'fallback-hero',
  title: 'Featured Products',
  image: '/images/banners/1.webp',
  link: '#'
}

const slides = computed(() => {
  return props.sliders && props.sliders.length > 0 ? props.sliders : fallbackSlides
})

const heroBanner = computed(() => {
  return props.heroBanner || fallbackHeroBanner
})

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % slides.value.length
}

const prevSlide = () => {
  currentSlide.value = currentSlide.value === 0 ? slides.value.length - 1 : currentSlide.value - 1
}


const startAutoPlay = () => {
  autoPlayInterval = setInterval(() => {
    nextSlide()
  }, 5000)
}

const stopAutoPlay = () => {
  if (autoPlayInterval) {
    clearInterval(autoPlayInterval)
  }
}

onMounted(() => {
  if (slides.value.length > 0) {
    startAutoPlay()
  }
})

onUnmounted(() => {
  stopAutoPlay()
})
</script>
